import * as Data$dFunction from "../Data.Function/index.js";
import * as Data$dMap$dInternal from "../Data.Map.Internal/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
const semigroupVault = {append: v => v1 => Data$dMap$dInternal.unsafeUnionWith(Data$dOrd.ordInt.compare, Data$dFunction.const, v, v1)};
const nextKey = {value: 0};
const newKey = () => {
  const $0 = nextKey.value;
  return nextKey.value = $0 + 1 | 0;
};
const lookup = k => v => {
  const $0 = Data$dMap$dInternal.lookup(Data$dOrd.ordInt)(k)(v);
  if ($0.tag === "Just") { return Data$dMaybe.$Maybe("Just", $0._1); }
  return Data$dMaybe.Nothing;
};
const insert = k => v => v1 => Data$dMap$dInternal.insert(Data$dOrd.ordInt)(k)(v)(v1);
const empty = Data$dMap$dInternal.Leaf;
const monoidVault = {mempty: Data$dMap$dInternal.Leaf, Semigroup0: () => semigroupVault};
const singleton = k => v => Data$dMap$dInternal.insert(Data$dOrd.ordInt)(k)(v)(Data$dMap$dInternal.Leaf);
export {empty, insert, lookup, monoidVault, newKey, nextKey, semigroupVault, singleton};
